import React from 'react';
import { useNavigate } from 'react-router-dom';

import { dateConvert } from '@app/components/Pages/PetMemorial/utils/dateConvert';
import CustomAvatar from '@app/components/UI/CustomAvatar/CustomAvatar';
import { TesAuthorCredits } from '@app/components/UI/VetTesCard/VetTesCard';
import imagePlaceholder from '@app/images/image-placeholder.png';
import { DatePost, PetMemorialCardProps } from '@app/objects/PetMemorial';
import { bodyOverflowTransform } from '@app/utils/bodyOverflowTransform';

const getCardClass = (text: string): string => {
	const length = text.length;

	if (length <= 160) return 'ht3';
	if (length <= 300) return 'ht4';
	if (length <= 400) return 'ht5';
	if (length <= 500) return 'ht6';
	if (length <= 560) return 'ht7';
	return 'ht8';
};

const PetMemorialCard: React.FC<PetMemorialCardProps> = ({ memorial, setModalVisible }) => {
	const navigate = useNavigate();

	const openModal = (e) => {
		e.preventDefault();
		navigate(`/pet-memorial/${memorial.id}`);
		bodyOverflowTransform(true);
		setModalVisible(true);
	};

	const [memorialDates, setMemorialDates] = React.useState<{
		dateBirth: string | null;
		datePass: string | null;
		datePost: DatePost;
	}>();

	const avatarHeight = 100;
	const avatarWidth = 100;

	React.useEffect(() => {
		setMemorialDates(dateConvert(memorial));
	}, [memorial]);

	const [imgSrc, setImgSrc] = React.useState(memorial.images[0]);

	React.useEffect(() => {
		setImgSrc(memorial?.images?.[0] || '');
	}, []);

	return (
		<a
			key={memorial.id}
			className={`pet-memorial-body__content-card ${getCardClass(memorial.message)}`}
			href={`/pet-memorial/${memorial.id}`}
			onClick={openModal}
		>
			<header className="pet-memorial-body__content-card-header">
				{imgSrc && (
					<div className="pet-memorial-body__content-card-header-img-wrap">
						<CustomAvatar
							src={imgSrc}
							maxWidth={avatarWidth}
							maxHeight={avatarHeight}
							alt={`Lap of Love Veterinary Hospice ${memorial.city ? memorial.city : ''}, ${memorial.state ? memorial.state : ''} 
								${memorial.petName ? `${memorial.petName}'s memorial ${memorial.firstName ? `by ${memorial.firstName} ${memorial.lastName}` : ''}` : ''}
							`}
							errorAvatar={imagePlaceholder}
						/>
					</div>
				)}
				<div className="pet-memorial-body__content-card-title">
					<h4>{memorial.petName}</h4>
					{memorialDates && (memorialDates.dateBirth || memorialDates.datePass) && (
						<div className="pet-memorial-body__content-card-lifetime">
							{memorialDates.dateBirth && (
								<>
									<span>{memorialDates.dateBirth}</span>
									<span> - </span>
								</>
							)}
							<span>{memorialDates.datePass || '...'}</span>
						</div>
					)}
				</div>
			</header>
			<div className="pet-memorial-body__content-card-text">
				<p>{memorial.message}</p>
			</div>
			<TesAuthorCredits
				firstName={memorial.firstName}
				lastName={memorial.lastName}
				city={memorial.city}
				state={memorial.state}
				date={dateConvert(memorial).datePost}
			/>
		</a>
	);
};

export default PetMemorialCard;
